export default {
  apiKey: "AIzaSyByibiqknvAevtxg97-j0jkegYYv_C0cic",
  authDomain: "getageek-d55a6.firebaseapp.com",
  databaseURL: "https://getageek-d55a6.firebaseio.com",
  projectId: "getageek-d55a6",
  storageBucket: "getageek-d55a6.appspot.com",
  messagingSenderId: "893615274260",
};



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js